import moment from 'moment'

export const isInSuspensionTime = (startTime, endTime) => {
    const current = moment().format('YYYY/MM/DD HH:mm');
    const from = moment(startTime).format('YYYY/MM/DD HH:mm');
    const to = moment(endTime).format('YYYY/MM/DD HH:mm');
    return moment(current).isBetween(from, to);
}